import { useContext } from "react";
import { ConfigurationsContext } from "./ConfigurationsContext";
import { ConfigurationsContextType } from "./ConfigurationsContextTypes";



export function useConfigurationsContext() {
    const context = useContext<ConfigurationsContextType | undefined>(ConfigurationsContext);
    if (!context) {
        throw new Error("useConfigurationsContext must be used within a ConfigurationsContextProvider");
    }
    return context;
}
